import React from 'react'
import KycFailWrapper from "./NewKyc.style";
import { ReactComponent as SadFace } from '../../assets/svg/sadFace.svg';
import { ReactComponent as Calling } from '../../assets/svg/call-outgoing.svg';
import { ReactComponent as Email } from '../../assets/svg/email.svg';
import { ReactComponent as Home } from '../../assets/svg/home.svg';
import { ReactComponent as Whatsapp } from '../../assets/svg/social-media-whatsapp.svg';
import { useTranslation } from 'react-i18next';
import logo from "../../assets/images/logos/Tawuniya-Logo_blue.svg"

const NewKyc = () => {
  const { t } = useTranslation();
  const handleCallcenterClick = (phone) => {
    window.open(phone);
  };
  const handlemailtoClick = (mail) => {
    window.open(mail);
  };
  const handleBackClick = (link) => {
    window.location.href = link;
  };

  const handleStartLiveChat = () => {
    window.open("https://wa.me/00966920019990");
  };


  return (
    <>
      <KycFailWrapper>
      <div className="d-flex align-items-center gap-2">
        <img src={logo} alt="logo" />
          <h3>{t("kyc.renewal")}</h3>
      </div>
        <SadFace />
        <h2 className='kyc-head'>{t("kyc.sorryMessage")}</h2>
        <p className='kyc-paragraph'>{t("kyc.contactMessage")}</p>
        <div className="contact-services">
          <div className="serv-box cursor-pointer" onClick={() => handleCallcenterClick('tel:8002481000')}>
            <Calling />
            <div className='supp-content d-flex flex-column'>
              <span>{t("kyc.callUs")}</span>
              <bdi>800 124 9990</bdi>
            </div>
          </div>
          <div class="vertical-line d-none d-lg-block"></div>
          <div className="serv-box cursor-pointer" onClick={handleStartLiveChat}>
            <Whatsapp />
            <div className='supp-content'>
              <span>{t("kyc.whatsApp")}</span><br/>
              <bdi>9200 19990</bdi>
            </div>
          </div>
          <div class="vertical-line d-none d-lg-block"></div>
          <div className="serv-box cursor-pointer" onClick={() => handlemailtoClick('mailto:info@tawuniya.com')}>
            <Email />
            <div className='supp-content'>
              <span>{t("kyc.email")}</span>
              <p>info@tawuniya.com</p>
            </div>
          </div>
        </div>
        <button onClick={() => handleBackClick("https://tawuniya.com")} className='btn-back'><Home />{t("kyc.BackTawuniya")}</button>
      </KycFailWrapper>
      </>
  )
}

export default NewKyc